import React, {useEffect, useState, useRef} from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy');



const BfFormstep11 = ({lang, setLang, nextStep, updateFormData, formData}) => {
 



  //multiple owners 

  
  const initialOwners = formData.step11?.owners || [{ owners_first_name_0: '' , owners_last_name_0: '' }];
  const [owners, setOwners] = useState(initialOwners);
  const removeOwner = (index) => {
    return new Promise((resolve) => {
      // Remove the owner at the specified index
      setOwners(prevOwners => {
        const updatedOwners = [...prevOwners];
        updatedOwners.splice(index, 1);
        return updatedOwners;
      }, resolve);
  
      // Create a new object for the updated form values
      const updatedFormValues = {};
  
      // Iterate over all form values
      for (const key in formik.values) {
        // If the key is for an owner field
        if (key.startsWith('owners_first_name_') || key.startsWith('owners_last_name_')) {
          // Get the index of the owner from the key
          const ownerIndex = parseInt(key.split('_').pop());
  
          // If the owner is before the removed owner, keep the key as is
          if (ownerIndex < index) {
            updatedFormValues[key] = formik.values[key];
          }
          // If the owner is after the removed owner, decrement the index in the key
          else if (ownerIndex > index) {
            const newKey = key.replace(/_[0-9]+$/, `_${ownerIndex - 1}`);
            updatedFormValues[newKey] = formik.values[key];
          }
          // If the owner is the removed owner, set the value to an empty string
          else {
            updatedFormValues[key] = "";
          }
        }
        // If the key is not for an owner field, keep it as is
        else {
          updatedFormValues[key] = formik.values[key];
        }
      }
  
      // Update the form values
      formik.setValues(updatedFormValues);
    });
  };
  
  useEffect(() => {
    lang=window.location.search.split("=")[1]
    if(lang === "es"){
      //console.log("lang is undefined")
      setLang("spa")
    }
    // Load the number of owners from formData when the component mounts or formData changes
    if (formData.step11?.owners) {
      setOwners(formData.step11.owners);
    }
  }, [formData.step11]);

  // Handler to add a new set of owner fields
  const addOwner = () => {
    const newOwner = { applicant_name: '', last_name: '' };
    setOwners([...owners, newOwner]);
  };

  // JSX for a single pair of owner fields
  const renderOwnerFields = (owner, index) => (
    <>
      {/* Owner's First Name */}
      <div className={`c-quote__item c-quote__item--50 ${formik.touched[`owners_first_name_${index}`] && formik.errors[`owners_first_name_${index}`] ? 'c-quote__error' : ''}`}>
        <label className="c-quote__label" htmlFor={`owners_first_name_${index}`}>
          {lang === 'eng' ? 'First Name' : 'Nombre'}
        </label>
        <input
          className={`c-quote__input only-letters ${formik.touched[`owners_first_name_${index}`] && formik.errors[`owners_first_name_${index}`] ? 'js-form-error' : ''}`}
          id={`owners_first_name_${index}`}
          type="text"
          name={`owners_first_name_${index}`}
          maxLength={50}
          minLength={2}
          required
          aria-required="true"
          aria-invalid={formik.touched[`owners_first_name_${index}`] && formik.errors[`owners_first_name_${index}`] ? 'true' : 'false'}
          onChange={e => handleNameInputChange(e, `owners_first_name_${index}`)}
          onBlur={formik.handleBlur}
          value={formik.values[`owners_first_name_${index}`]}
        />
        {formik.touched[`owners_first_name_${index}`] && formik.errors[`owners_first_name_${index}`] && (
          <label id={`owners_first_name_${index}-error`} className="js-form-error" htmlFor={`owners_first_name_${index}`}>
            {formik.errors[`owners_first_name_${index}`]}
          </label>
        )}
     
      </div>
      

      {/* Owner's Last Name */}
      <div className={`c-quote__item c-quote__item--50 ${formik.touched[`owners_last_name_${index}`] && formik.errors[`owners_last_name_${index}`] ? 'c-quote__error' : ''}`}>
        <label className="c-quote__label" htmlFor={`owners_last_name_${index}`}>
          {lang === 'eng' ? 'Last Name' : 'Apellido'}
        </label>
        <input
          className={`c-quote__input only-letters ${formik.touched[`owners_last_name_${index}`] && formik.errors[`owners_last_name_${index}`] ? 'js-form-error' : ''}`}
          id={`owners_last_name_${index}`}
          type="text"
          name={`owners_last_name_${index}`}
          maxLength={50}
          required
          aria-required="true"
          aria-invalid={formik.touched[`owners_last_name_${index}`] && formik.errors[`owners_last_name_${index}`] ? 'true' : 'false'}
          onChange={e => handleNameInputChange(e, `owners_last_name_${index}`)}
          onBlur={formik.handleBlur}
          value={formik.values[`owners_last_name_${index}`]}
        />
        {formik.touched[`owners_last_name_${index}`] && formik.errors[`owners_last_name_${index}`] && (
          <label id={`owners_last_name_${index}-error`} className="js-form-error" htmlFor={`owners_last_name_${index}`}>
            {formik.errors[`owners_last_name_${index}`]}
          </label>
        )}
        <button key={index} className="c-quote__btn-delete " type="button" onClick={() => removeOwner(index)} 
        style={
          window.innerWidth <= 768 && formik.touched[`owners_last_name_${index}`] && formik.errors[`owners_last_name_${index}`]
            ? formik.values[`owners_last_name_${index}`].length === 1
              ? { top: '-20px' }
              : { top: '0px' }
            : window.innerWidth > 768 && formik.touched[`owners_last_name_${index}`] && formik.errors[`owners_last_name_${index}`]
              ? { top: '0px' }
              : {}
        }
>
          <span className="o-icon">
              <svg aria-hidden="true" focusable="false" role="img">
                  <use href="images/icons/icons.svg#icon-delete" />
              </svg>
          </span>
      </button>

      </div>
   
     
   
    </>
  );




  const getFirstErrorKey = (object, keys = []) => {
    const isObject = (value) => {
      return value != null && typeof value === 'object' && !Array.isArray(value);
    };
    
    const firstErrorKey = Object.keys(object)[0];
    if (isObject(object[firstErrorKey])) {
      return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
    }
    return [...keys, firstErrorKey].join(".");
  };


  const formatPhoneNumber = (e, fieldName) => {
    let input = e.target.value.replace(/\D/g, '');
    input = input.substring(0, 10);
    const area = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    let formatted = '';

    if (area.length > 0) {
      formatted += area;
    }

    if (middle.length > 0) {
      formatted += `-${middle}`;
    }

    if (last.length > 0) {
      formatted += `-${last}`;
    }

    formik.setFieldValue(fieldName, formatted);
  };


  const handleLetterInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter out non-letter characters
    const lettersOnlyValue = inputValue.replace(/[^a-zA-Z ]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, lettersOnlyValue);
  }
  const handleAlphanumInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter to allow only letters, numbers, and hyphen
    const alphanumValue = inputValue.replace(/[^a-zA-Z0-9-]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, alphanumValue);
  }
  
  const handleExtendedInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter to allow only letters, numbers, hyphen, commas, periods, apostrophes, ñ, Spanish vowels with tildes, and |
    const extendedValue = inputValue.replace(/[^a-zA-Z0-9-,.ñáéíóúüÁÉÍÓÚÜ| ']/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, extendedValue);
  }
  const handleNameInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter to allow only letters, hyphen, commas, periods, apostrophes, ñ, Spanish vowels with tildes, and |
    const extendedValue = inputValue.replace(/[^a-zA-Z-,.ñáéíóúüÁÉÍÓÚÜ| ']/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, extendedValue);
  }
  const handleNumberInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter out non-number characters
    const numbersOnlyValue = inputValue.replace(/[^0-9]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, numbersOnlyValue);
  }

  const initialStep11Values = {
    applicant_name: "",
   
    owners_first_name_0: "",
    owners_last_name_0: "",
    owners_first_name_1: "",
    owners_last_name_1: "",
    owners_first_name_2: "",
    owners_last_name_2: "",
    owners_first_name_3: "",
    owners_last_name_3: "",
    owners_first_name_4: "",
    owners_last_name_4: "",
    owners_first_name_5: "",
    owners_last_name_5: "",

    owners_usdot_no: "",
    owners_mc_no: "",
    owners_years_in_business: "",
    owners_applicant_address: "",
    owners_email: "",
    owners_business_phone: "",
    owners_contact_no: "",
    owners_policy_effective_date: null, 
  };

  const messages = {
    min: lang === 'eng' ? "Please enter at least 2 characters" : "Por favor, ingrese al menos 2 caracteres",
    required: lang === 'eng' ? "This field is required" : "Este campo es obligatorio",
    email: lang === 'eng' ? "Please enter a valid email address" : "Por favor, ingrese una dirección de correo electrónico válida",
    phone: lang === 'eng' ? 'Please enter 10 digits' : 'Por favor, ingrese 10 dígitos',
    moreThan: lang === 'eng' ? "Please select an option" : "Por favor, seleccione una opción"
  };
  
  const generateValidationSchema = (ownersLength) => {
    let schema = {
      
      owners_first_name_0: Yup.string().min(2, messages.min).required(messages.required),
      owners_last_name_0: Yup.string().min(2, messages.min).required(messages.required),
      applicant_name: Yup.string()
        .min(2, messages.min)
        .required(messages.required),
      owners_usdot_no: Yup.string()
        .required(messages.required)
        .min(2, messages.min),
      owners_mc_no: Yup.string()
        .min(2, messages.min)
        .required(messages.required),
      owners_years_in_business: Yup.string()
        .required(messages.required),
      owners_applicant_address: Yup.string()
        .min(2, messages.min),
      owners_business_phone: Yup.string()
        .matches(/^\d{3}-\d{3}-\d{4}$/, messages.phone)
        .test('oneOfRequired', messages.required, function() {
          const { owners_business_phone, owners_contact_no } = this.parent;
          return owners_business_phone || owners_contact_no;
        }),
      owners_contact_no: Yup.string()
        .matches(/^\d{3}-\d{3}-\d{4}$/, messages.phone)
        .test('oneOfRequired', messages.required, function() {
          const { owners_business_phone, owners_contact_no } = this.parent;
          return owners_business_phone || owners_contact_no;
        }),
      owners_email: Yup.string()
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          messages.email
        )
        .required(messages.required),
      owners_policy_effective_date: Yup.string()
        .min(2, messages.min)
        .required(messages.required), 
    };
  
    
    for (let i = 1; i < ownersLength; i++) {
      schema[`owners_first_name_${i}`] = Yup.string()
        .min(2, messages.min)
        .test('eitherEmptyOrRequired', messages.required, function (value) {
          const { path, parent } = this;
          const otherPath = path.replace('first_name', 'last_name');
          const otherValue = parent[otherPath];
    
          // Show error message only if the current field is empty and the other field is not empty
          return (!value && otherValue) ? false : true;
        });
    
      schema[`owners_last_name_${i}`] = Yup.string()
        .min(2, messages.min)
        .test('eitherEmptyOrRequired', messages.required, function (value) {
          const { path, parent } = this;
          const otherPath = path.replace('last_name', 'first_name');
          const otherValue = parent[otherPath];
    
          // Show error message only if the current field is empty and the other field is not empty
          return (!value && otherValue) ? false : true;
        });
    }
    
  
    return Yup.object().shape(schema);
  };
  
  const validationschema = generateValidationSchema(owners.length);
  //useeffect print formdata
  useEffect(() => {
    console.log(formData);
  }, [formData]);

  if (formData.step11) {
    // If formData.step11 exists, map the initial values from it
    Object.assign(initialStep11Values, formData.step11);
    
    // If individual address fields exist, combine them into one full address string
    if (formData.step11.owners_address && formData.step11.owners_city && formData.step11.owners_state && formData.step11.owners_zip_code) {
      initialStep11Values.owners_applicant_address = `${formData.step11.owners_address}, ${formData.step11.owners_city}, ${formData.step11.owners_state} ${formData.step11.owners_zip_code}`;
    }
    
    if (formData.step11.owners_policy_effective_date) {
      initialStep11Values.owners_policy_effective_date = new Date(formData.step11.owners_policy_effective_date);
    }

    //if the business phone number exists, separate the country code and phone number and put them in their respectve fields
    if (formData.step11.owners_business_phone) {

      const [countryCode, phoneNumber] = formData.step11.owners_business_phone.split(' ');
      initialStep11Values.owners_country_code = countryCode || 'DefaultCountryCode';
      initialStep11Values.owners_business_phone = phoneNumber || formData.step11.owners_business_phone;
    }
    //if the contact phone number exists, separate the country code and phone number and put them in their respectve fields
    if (formData.step11.phone) {
   
      //+1 123-132-1321
      const [countryCode, phoneNumber] = formData.step11.phone.split(' ');
      initialStep11Values.contact_country_code = countryCode;
      initialStep11Values.owners_contact_no = phoneNumber;
    }
    

    //add the owner's name from the array respectievly to their fields
    if(formData.step11.owners){
    formData.step11.owners.forEach((owner, index) => {
      initialStep11Values[`owners_first_name_${index}`] = owner.first_name;
      initialStep11Values[`owners_last_name_${index}`] = owner.last_name;
    });
  }
}
  const formik = useFormik({
    initialValues: initialStep11Values,
    
    validationSchema:validationschema,
    onSubmit: (values) => {
      // Initialize an array to store the owners
      const owners = [];
    
    // Loop through all properties in the 'values' object
for (const key in values) {
  if (key.startsWith('owners_first_name_') && values[key]) {
    // Get the index from the property name
    const index = key.replace('owners_first_name_', '');

    // Build the owner object
    const owner = {
      first_name: values[key],
      last_name: values[`owners_last_name_${index}`]
    };

    // Only push the owner object into the 'owners' array if both fields are not blank
    if (owner.first_name.trim() !== '' && owner.last_name.trim() !== '') {
      owners.push(owner);
    }
  }
}
    
      // Concatenate country codes with phone numbers
      if (values.owners_country_code && values.owners_business_phone) {
        values.owners_business_phone = `${values.owners_country_code+ ' '}${values.owners_business_phone}`;
        delete values.owners_country_code;
      }
    
      if (values.contact_country_code && values.owners_contact_no) {
        values.phone = `${values.contact_country_code + ' '}${values.owners_contact_no}`;
        delete values.contact_country_code;
        delete values.owners_contact_no;
      }
    
      // Remove the individual owner properties from the values object
      for (const key in values) {
        if (key.startsWith('owners_first_name_') || key.startsWith('owners_last_name_')) {
          delete values[key];
        }
      }
    
      // Set the 'owners' property in the values object
      values.owners = owners;
      //iterate through the values, if any of them is undefined, then send as ''
      for (const key in values) {
        if (values[key] === undefined) {
          values[key] = '';
        }
      }
      
      

      updateFormData(values); // You might need to adjust this function to handle the new structure
      nextStep();
    },
    
    
  });

  useEffect(() => {
    if (!formik.isValid && formik.submitCount !== 0 && formik.isSubmitting) {
      const firstErrorKey = getFirstErrorKey(formik.errors);
      if (global.window.document.getElementsByName(firstErrorKey).length) {
        global.window.document.getElementsByName(firstErrorKey)[0].focus();
      }
    }
  }, [formik.submitCount, formik.isValid, formik.errors, formik.isSubmitting]);



  //addreess functionality
  const addressInputRef = useRef(null);
  useEffect(() => {
    let isAutocompleteValue = false;

    //if the address values already exist, set city state and zipcode as undefined
    if(formik.values.owners_address !== undefined && formik.values.owners_city !== undefined && formik.values.owners_state !== undefined && formik.values.owners_zip_code !== undefined){
      //if the values of state city and zipcode are from included in the formattedaddress, then do nothing
      if(formik.values.owners_applicant_address.includes(formik.values.owners_state) && formik.values.owners_applicant_address.includes(formik.values.owners_city) && formik.values.owners_applicant_address.includes(formik.values.owners_zip_code)){
        console.log("do nothing")
      }
      else{
        formik.values.owners_city = undefined
        formik.values.owners_state = undefined
        formik.values.owners_zip_code = undefined

      }
      
  
    }

    const initAutocomplete = () => {
      if (!addressInputRef.current || !window.google) return;

      const autocomplete = new window.google.maps.places.Autocomplete(addressInputRef.current, { types: ['address'] });
      autocomplete.setFields(['address_components', 'formatted_address']);

      addressInputRef.current.addEventListener('input', () => {
        isAutocompleteValue = false;
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();

        if (!place.address_components) {
          clearFormFields();
          return;
        }

        let address = '';
        let city = '';
        let state = '';
        let zipCode = '';

        place.address_components.forEach(component => {
          const componentType = component.types[0];

          switch (componentType) {
            case 'street_number':
              address = `${component.long_name} ${address}`;
              break;
            case 'route':
              address += component.short_name;
              break;
            case 'locality':
              city = component.long_name;
              break;
            case 'administrative_area_level_1':
              state = component.short_name;
              break;
            case 'postal_code':
              zipCode = component.long_name;
              break;
          }
        });

        let formattedAddress = `${address}, ${city}, ${state} ${zipCode}`;

        updateFormFields(formattedAddress, address, city, state, zipCode);
        console.log("formattedadres", formattedAddress)
        console.log("address", address)
        console.log("city", city)
        console.log("state", state)
        console.log("zipCode", zipCode)
      });
    };

    const clearFormFields = () => {
      formik.setFieldValue('owners_applicant_address', '');
      formik.setFieldValue('owners_address', '');
      formik.setFieldValue('owners_city', '');
      formik.setFieldValue('owners_state', '');
      formik.setFieldValue('owners_zip_code', '');
    };

    const updateFormFields = (formattedAddress, address, city, state, zipCode) => {
      //console log formattedadres adres city state and zipcode 
     

      formik.setFieldValue('owners_applicant_address', formattedAddress.trim());
      formik.setFieldValue('owners_address', address.trim());
      formik.setFieldValue('owners_city', city.trim());
      formik.setFieldValue('owners_state', state.trim());
      formik.setFieldValue('owners_zip_code', zipCode.trim());
    };

    const loadGoogleMapsApi = () => {
      if (window.google) {
        initAutocomplete();
      } else {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBqLNiTFlveyp2pC266ZAB0hSsWQrANpLE&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = initAutocomplete;
        document.body.appendChild(script);
      }
    };

    // Load the Google Places Autocomplete
    loadGoogleMapsApi();
    if (addressInputRef.current) {
      addressInputRef.current.addEventListener('blur', () => {
        if (!isAutocompleteValue && !addressInputRef.current.value) {
          clearFormFields();
        }
        isAutocompleteValue = false;
      });
    }
    console.log("this useffect is being cvalled")
    console.log("formattedAdress", formik.values.owners_applicant_address)
    console.log("address", formik.values.owners_address)
    console.log("city", formik.values.owners_city)
    console.log("state", formik.values.owners_state)
    console.log("zipCode", formik.values.owners_zip_code)
    console.log(formik.values)

    //if address city state and zipcode are undefined, set address as formattedaddress
    if(formik.values.owners_city === undefined && formik.values.owners_state === undefined && formik.values.owners_zip_code === undefined){
      formik.values.owners_address = formik.values.owners_applicant_address
    }
  }, [formik.values.owners_applicant_address]);




  useEffect(() => {
    formik.validateForm();
  }, [formik.values]);


  const renderOwners = () => {
    return owners.slice(1).map((owner, index) => renderOwnerFields(owner, index + 1));
  };
  
  return (
    <>
<>

  <header className="c-site-header">
    <a className="c-site-header__skip js-site-header-skip" href="#main">
      Skip to main content
    </a>
    <div className="o-wrapper">
      <a
        className="c-site-header__logo-link"
        href="./"
        aria-label="Go to home page"
      >
        <img
          className="c-site-header__logo"
          src="images/components/site-header/logo-blf-specialty.svg"
          alt="Bluefire Specialty Logo"
          width={100}
          height={34}
        />
      </a>
      <h1 className="c-site-header__title">
        <span className="o-icon">
          <svg aria-hidden="true" focusable="false" role="img">
            <use href="images/icons/icons.svg#icon-form" />
          </svg>
        </span>
        
        {lang === 'eng' ? 'Quote Application for Buses Insurance' : 'Solicitud de cotización para seguro de autobuses'}
      </h1>
      <div className="c-site-header__controls c-header-controls">
  <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
</div>

    </div>
  </header>
  <main className="c-main-content">
    <div className="c-section">
      <div className="o-wrapper o-wrapper--">
        <h1 className="c-section__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-form" />
            </svg>
          </span>
          {lang === 'eng' ? 'Quote Application for Buses Insurance' : 'Solicitud de cotización para seguro de autobuses'}
        </h1>


        <div className="c-section__content">
          <div className="c-steps">
            <ul className="o-list-bare c-steps__list">
              <li className="o-list-bare__item c-steps__item c-steps__item c-steps__item--20 c-steps__step--active">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
            </ul>
          </div>

          {/*form start */}
          <div className="c-content">
            <div className="c-quote">
            <form 
              onSubmit={formik.handleSubmit} 
              className="c-quote__form js-form" 
              noValidate
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                }
              }}
            >
               
               {/* Applicant's Name */}
               
                <h2 className="c-quote__title">{lang === 'eng' ? 'Applicant / Company Name' : 'Nombre del solicitante / Empresa' }</h2>
          
              <div className={`c-quote__item c-quote__item--100 ${formik.touched.applicant_name && formik.errors.applicant_name ? 'c-quote__error' : ''}`}>
                <label className="c-quote__label" htmlFor="applicant_name">
                 {lang === 'eng' ? '  Name ' : 'Nombre'} 
                </label>
                <input
                  className={`c-quote__input only-letters ${formik.touched.applicant_name && formik.errors.applicant_name ? 'js-form-error' : ''}`}
                  id="applicant_name"
                  type="text"
                  name="applicant_name"
                  maxLength={50}
                  required
                  aria-required="true"
                  aria-invalid={formik.touched.applicant_name && formik.errors.applicant_name ? 'true' : 'false'}
                  onChange={e => handleExtendedInputChange(e, 'applicant_name')}
                  onBlur={formik.handleBlur}
                  value={formik.values.applicant_name}
                />
                {formik.touched.applicant_name && formik.errors.applicant_name ? (
                  <label id="applicant_name-error" className="js-form-error" htmlFor="applicant_name">
                    {formik.errors.applicant_name}
                  </label>
                ) : null}
              </div>


         {/* Owner's Name - First Name */}
<h2 className="c-quote__title"> {lang === 'eng' ? 'Owner\'s Name' : 'Nombre del propietario'}</h2>
<div className={`c-quote__item c-quote__item--50 ${formik.touched.owners_first_name_0 && formik.errors.owners_first_name_0 ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_first_name_0">
    {lang === 'eng' ? 'First Name' : 'Nombre'} 
  </label>
  <input
    className={`c-quote__input only-letters ${formik.touched.owners_first_name_0 && formik.errors.owners_first_name_0 ? 'js-form-error' : ''}`}
    id="owners_first_name_0"
    type="text"
    name="owners_first_name_0"
    maxLength={50}
    minLength={2}
    required
    aria-required="true"
    aria-invalid={formik.touched.owners_first_name_0 && formik.errors.owners_first_name_0 ? 'true' : 'false'}
    onChange={e => handleNameInputChange(e, 'owners_first_name_0')}
    onBlur={formik.handleBlur}
    value={formik.values.owners_first_name_0}
  />
  {formik.touched.owners_first_name_0 && formik.errors.owners_first_name_0 ? (
    <label id="owners_first_name_0-error" className="js-form-error" htmlFor="owners_first_name_0">
      {formik.errors.owners_first_name_0}
      </label>
  ) : null}
</div>


            {/* Owner's Last Name */}
<div className={`c-quote__item c-quote__item--50 ${formik.touched.owners_last_name_0 && formik.errors.owners_last_name_0 ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_last_name_0">
    {lang === 'eng' ? 'Last Name' : 'Apellido'}
  </label>
  <input
    className={`c-quote__input only-letters ${formik.touched.owners_last_name_0 && formik.errors.owners_last_name_0 ? 'js-form-error' : ''}`}
    id="owners_last_name_0"
    type="text"
    name="owners_last_name_0"
    maxLength={50}
    required
    aria-required="true"
    owners_policy_effective_date
    onChange={e => handleNameInputChange(e, 'owners_last_name_0')}
    onBlur={formik.handleBlur}
    value={formik.values.owners_last_name_0}
  />
  {formik.touched.owners_last_name_0 && formik.errors.owners_last_name_0 ? (
    <label id="owners_last_name_0-error" className="js-form-error" htmlFor="owners_last_name_0">
      {formik.errors.owners_last_name_0}
      </label>
  ) : null}
</div>

{renderOwners()}


<div className='c-quote__item c-quote__item--100'>
<button type="button" className="c-quote__add-owner-btn" onClick={addOwner}
//disable if index is greater than 5  
disabled={owners.length > 5}
>

  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className="icon">
    <path d="M9.00775 0.0078125C4.04651 0.0078125 0 4.03882 0 9.00006C0 13.9613 4.03101 17.9923 9.00775 17.9923C13.969 17.9923 18 13.9613 18 9.00006C18 4.03882 13.969 0.0078125 9.00775 0.0078125ZM9.00775 16.7365C4.74418 16.7365 1.27132 13.2636 1.27132 9.00006C1.27132 4.73649 4.74418 1.26363 9.00775 1.26363C13.2713 1.26363 16.7442 4.73649 16.7442 9.00006C16.7442 13.2636 13.2713 16.7365 9.00775 16.7365Z" fill="#0085FF"/>
    <path d="M13.1471 8.28687H9.64327V4.7675C9.64327 4.41091 9.3642 4.13184 9.00761 4.13184C8.65103 4.13184 8.37196 4.41091 8.37196 4.7675V8.27137H4.86808C4.51149 8.27137 4.23242 8.55044 4.23242 8.90703C4.23242 9.26362 4.51149 9.54269 4.86808 9.54269H8.37196V13.0466C8.37196 13.4032 8.65103 13.6822 9.00761 13.6822C9.36420 13.6822 9.64327 13.4032 9.64327 13.0466V9.54269H13.1471C13.5037 9.54269 13.7828 9.26362 13.7828 8.90703C13.7828 8.55044 13.5037 8.28687 13.1471 8.28687Z" fill="#0085FF"/>
  </svg>
  {owners.length > 5 
  ? (lang === 'eng' ? "Maximum owners reached" : "Número máximo de propietarios alcanzado.") 
  : (lang === 'eng' ? 'Add another Owner' : 'Añadir más propietarios')
}
</button>

</div>

{/* USDOT No. */}
<div className={`c-quote__item c-quote__item--50 ${formik.touched.owners_usdot_no && formik.errors.owners_usdot_no ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_usdot_no">
    {lang === 'eng' ? 'USDOT No.' : 'No. USDOT'}
  </label>
  <input
    className={`c-quote__input only-letters ${formik.touched.owners_usdot_no && formik.errors.owners_usdot_no ? 'js-form-error' : ''}`}
    id="owners_usdot_no"
    type="text"
    name="owners_usdot_no"
    maxLength={8}
    required
    aria-required="true"
    aria-invalid={formik.touched.owners_usdot_no && formik.errors.owners_usdot_no ? 'true' : 'false'}
    onChange={e => handleAlphanumInputChange(e, 'owners_usdot_no')}
    onBlur={formik.handleBlur}
    value={formik.values.owners_usdot_no}
  />
  {formik.touched.owners_usdot_no && formik.errors.owners_usdot_no ? (
    <label id="owners_usdot_no-error" className="js-form-error" htmlFor="owners_usdot_no">
      {formik.errors.owners_usdot_no}
      </label>
  ) : null}
</div>
{/* MC No. */}
<div className={`c-quote__item c-quote__item--50 ${formik.touched.owners_mc_no && formik.errors.owners_mc_no ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_mc_no">
    {lang === 'eng' ? 'MC No.' : 'No. MC'}
  </label>
  <input
    className={`c-quote__input only-digits ${formik.touched.owners_mc_no && formik.errors.owners_mc_no ? 'js-form-error' : ''}`}
    id="owners_mc_no"
    type="text"
    name="owners_mc_no"
    maxLength={10}

    required
    aria-required="true"
    aria-invalid={formik.touched.owners_mc_no && formik.errors.owners_mc_no ? 'true' : 'false'}
    onChange={e => handleAlphanumInputChange(e, 'owners_mc_no')}
    onBlur={formik.handleBlur}
    value={formik.values.owners_mc_no}
  />
  {formik.touched.owners_mc_no && formik.errors.owners_mc_no ? (
    <label id="owners_mc_no-error" className="js-form-error" htmlFor="owners_mc_no">
      {formik.errors.owners_mc_no}
      </label>
  ) : null}
</div>


               {/* Years in Business */}
<div className={`c-quote__item c-quote__item--50 ${formik.touched.owners_years_in_business && formik.errors.owners_years_in_business ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_years_in_business">
    {lang === 'eng' ? 'Years in Business' : 'Años de experiencia'}
  </label>
  <select
  className={`c-quote__select js-valid-select ${formik.touched.owners_years_in_business && formik.errors.owners_years_in_business ? 'js-form-error' : ''}`}
  id="owners_years_in_business"
  name="owners_years_in_business"
  required
  aria-required="true"
  aria-invalid={formik.touched.owners_years_in_business && formik.errors.owners_years_in_business ? 'true' : 'false'}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
  value={formik.values.owners_years_in_business}
>
  <option value="" disabled>
    {lang === 'eng' ? 'Select an option' : 'Seleccione una opción'}
  </option>
  {[...Array(9)].map((_, i) => (
    <option key={i + 1} value={i + 1}>
      {i + 1}  {lang === 'eng' ? 'year' : 'año'}{`${i !== 0 ? 's' : ''}`}
    </option>
  ))}
 <option value="10+" >
    {lang === 'eng' ? '10+ Years' : '10+ años'}
  </option>
</select>
  {formik.touched.owners_years_in_business && formik.errors.owners_years_in_business ? (
    <label id="owners_years_in_business-error" className="js-form-error" htmlFor="owners_years_in_business">
      {formik.errors.owners_years_in_business}
      </label>
  ) : null}
</div>


    {/* Applicant Address at DOT */}
<div className={`c-quote__item c-quote__item--100 ${formik.touched.owners_applicant_address && formik.errors.owners_applicant_address ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_applicant_address">
    {lang === 'eng' ? 'Applicant\'s Physical Address' : 'Dirección física del solicitante'}
  </label>
  <input
    className={`c-quote__input ${formik.touched.owners_applicant_address && formik.errors.owners_applicant_address ? 'js-form-error' : ''}`}
    ref={addressInputRef}
    id="owners_applicant_address"
    placeholder=''
    type="text"
    name="owners_applicant_address"
    maxLength={150}
    minLength={3}
    required
    aria-required="true"
    aria-invalid={formik.touched.owners_applicant_address && formik.errors.owners_applicant_address ? 'true' : 'false'}
    onChange={formik.handleChange }
    onBlur={formik.handleBlur}
    value={formik.values.owners_applicant_address}
  />
  {formik.touched.owners_applicant_address && formik.errors.owners_applicant_address ? (
    <label id="owners_applicant_address-error" className="js-form-error" htmlFor="owners_applicant_address">
      {formik.errors.owners_applicant_address}
    </label>
  ) : null}
</div>

{/* Email */}
<div className={`c-quote__item c-quote__item--100 ${formik.touched.owners_email && formik.errors.owners_email ? 'c-quote__error' : ''}`}>
  <label className="c-quote__label" htmlFor="owners_email">
    Email 
  </label>
  <input
    className={`c-quote__input ${formik.touched.owners_email && formik.errors.owners_email ? 'js-form-error' : ''}`}
    id="owners_email"
    type="owners_email"
    name="owners_email"
    maxLength={50}
    required
    aria-required="true"
    aria-invalid={formik.touched.owners_email && formik.errors.owners_email ? 'true' : 'false'}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    value={formik.values.owners_email}
  />
  {formik.touched.owners_email && formik.errors.owners_email ? (
    <label id="owners_email-error" className="js-form-error" htmlFor="owners_email">
      {formik.errors.owners_email}
      </label>
  ) : null}
</div>

<div className='c-quote__item--double'>

  {/* Country Code */}
  <div className='c-quote__item c-quote__item--double_item'>
    <label className='c-quote__label' htmlFor='owners_country_code'>
      {lang === 'eng' ? 'Country Code' : 'Código de país'}
    </label>
    <select
      className='c-quote__select js-valid-select'
      id='owners_country_code'
      name='owners_country_code'
      required
      aria-required="true"
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.owners_country_code}
    >
      <option value='' selected> </option>
      <option value='+1'>+1(US)</option>
      <option value='+52'>+52(MX)</option>
      
    </select>
  </div>

  {/* Business Phone */}
  <div className='c-quote__item c-quote__item--double_item'>
    <label className='c-quote__label' htmlFor='owners_business_phone'>
      {lang === 'eng' ? 'Business Phone' : 'Teléfono de negocio'}
    </label>
    <input
      className={`c-quote__input ${formik.touched.owners_business_phone && formik.errors.owners_business_phone ? 'js-form-error' : ''}`}
      id='owners_business_phone'
      type='text'
      name='owners_business_phone'
      maxLength={12}
      minLength={3}
      inputMode='numeric'
      required
      aria-required="true"
      aria-invalid={formik.touched.owners_business_phone && formik.errors.owners_business_phone ? 'true' : 'false'}
      onChange={e => formatPhoneNumber(e, 'owners_business_phone')}
      onBlur={formik.handleBlur}
      value={formik.values.owners_business_phone}
    />
    {formik.touched.owners_business_phone && formik.errors.owners_business_phone && (
      <label id='owners_business_phone-error' className='js-form-error' htmlFor='owners_business_phone'>
        {formik.errors.owners_business_phone}
      </label>
    )}
  </div>

</div>

<div className="c-quote__item--double">

  {/* Country Code for Contact No. */}
  <div className="c-quote__item c-quote__item--double_item">
    <label className="c-quote__label" htmlFor="contact_country_code">
      {lang === 'eng' ? 'Country Code' : 'Código de país'}
    </label>
    <select
      className="c-quote__select js-valid-select"
      id="contact_country_code"
      name="contact_country_code"
      required
      aria-required="true"
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.contact_country_code}
    >
      <option value="" selected> </option>
      <option value="+1">+1 (US)</option>
      <option value="+52">+52 (MX)</option>
      {/* Add more country codes as needed */}
    </select>
  </div>

  {/* Contact Phone No. */}
  <div className="c-quote__item c-quote__item--double_item">
    <label className="c-quote__label" htmlFor="owners_contact_no">
      {lang === 'eng' ? 'Contact Phone' : 'No. De contacto'}
    </label>
    <input
      className={`c-quote__input ${formik.touched.owners_contact_no && formik.errors.owners_contact_no ? 'js-form-error' : ''}`}
      id="owners_contact_no"
      type="text"
      name="owners_contact_no"
      maxLength={12}
      minLength={3}
      inputMode="numeric"
      required
      aria-required="true"
      aria-invalid={formik.touched.owners_contact_no && formik.errors.owners_contact_no ? 'true' : 'false'}
      onChange={e => formatPhoneNumber(e, 'owners_contact_no')}
      onBlur={formik.handleBlur}
      value={formik.values.owners_contact_no}
    />
    {formik.touched.owners_contact_no && formik.errors.owners_contact_no && (
      <label id="owners_contact_no-error" className="js-form-error" htmlFor="owners_contact_no">
        {formik.errors.owners_contact_no}
      </label>
    )}
  </div>

</div>
 {/* Date of Birth */}
 <div className="c-quote__item c-quote__item--50">
      <label className="c-quote__label" htmlFor="owners_policy_effective_date">
        {lang === 'eng' ? 'Policy Effective Date' : 'Fecha de vigencia de la póliza'}
      </label>
      <DatePicker
  className={`c-quote__input ${formik.values.owners_policy_effective_date ? '' : 'c-quote__input--dob'} ${formik.touched.owners_policy_effective_date && formik.errors.owners_policy_effective_date ? 'js-form-error' : ''}`}
  id="owners_policy_effective_date"
  showMonthDropdown
  showYearDropdown
  dropdownMode="select"
  maxDate={new Date(new Date().getFullYear() + 10, 11, 31)} 
  name="owners_policy_effective_date"
  selected={formik.values.owners_policy_effective_date}
  onChange={(date) => formik.setFieldValue("owners_policy_effective_date", date)}
  dateFormat="MM/dd/yyyy"
  placeholderText={lang === 'eng' ? 'MM/DD/YYYY' : 'MM/DD/AAAA'}
  customInput={
    <MaskedInput
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      pipe={autoCorrectedDatePipe}
      keepCharPositions
    />
  }
  isClearable
/>

      {formik.touched.owners_policy_effective_date && formik.errors.owners_policy_effective_date && (
        <label id="owners_policy_effective_date" className="js-form-error" htmlFor="owners_policy_effective_date">
          {formik.errors.owners_policy_effective_date}
        </label>
      )}
    </div>





                <div className="c-quote__controls">
                <button
                type='submit'
  className="c-quote__control c-quote__control--submit c-button c-button--blue-light"
  

>
  {lang === 'eng' ? 'Continue' : 'Continuar'}
</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
</>

    </>
  )
}

export default BfFormstep11;
